export const MAX_STUDENTS_IN_CLASS = 30;
